import i18n from 'i18next';
import * as Categories from 'components/SharedComponents/categories';
const defaultPopularCategoryDisplayName = 'Most Popular';
const defaultPopularCategory = 'ANY';
const defaultContentCount = 20;

class HomePageHelper {

    constructor() {
        this._defaultCategory = defaultPopularCategory;
        this._defaultContentCount = defaultContentCount;
        this._popularCategories = {};
    }

    /**
     * Sets the categories to be displayed on the navigation bar, returned by the recommendation service
     * @param popularContents
     */
    set popularCategories(popularContents) {
        if (popularContents) {
            this._popularCategories = popularContents;
        } else {
            this._popularCategories = {};
        }
    }

    /**
     *
     * @returns {*}
     */
    get popularCategories() {
        return this._popularCategories;
    }

    /**
     *
     * @returns {*}
     */
    get defaultCategory() {
        return this._defaultCategory;
    }

    /**
     *
     * @returns {number|*}
     */
    get defaultContentCount() {
        return this._defaultContentCount;
    }

    /**
     * Returns the display string for the nav bar category buttons
     * @param category
     * @returns {string}
     */
    static getCategoryDisplayName(category) {
        switch (category) {

        case defaultPopularCategory:
            return defaultPopularCategoryDisplayName;

        default:
            return i18n.t(`categories.${category}`);
        }
    }

    /**
     * Returns the Icon for the nav bar category buttons
     * @param category
     * @returns {string}
     */
    static getCategoryDisplayIcon(category) {
        return (Categories.categoriesIcon && Categories.categoriesIcon[category]) ? Categories.categoriesIcon[category] : null;
    }
}


export default HomePageHelper;



// WEBPACK FOOTER //
// ./src/components/home-page/home-page-helper.js